import React from 'react';
import dateFormat from 'dateformat';

// STYLEDS
import * as S from './SearchWidgetUI.styles';
import * as styles from '../Autosuggests/SearchWidget/SearchWidgetAutosuggest.styles';

// COMPONENTS
import SearchWidgetAutosuggest from '../Autosuggests/SearchWidget/SearchWidgetAutosuggest';
import CalendarBlock from '../../HomePage/CalendarBlock/CalendarBlockv2';
import PaxWidget from '../../HomePage/PaxWidget/PaxWidget';

// UTILS
import {convertRoomStringToReadable} from '../../../../../shared/utils/room-string-utils';
import {twoDatesAreSame} from '../../../../../shared/utils/date-utils';

// HOOKS
import useSearchWidgetUI from '../../../../../shared/hooks/useSearchWidgetUI';

const SearchWidgetUI = ({
  updateQueryCaller,
  autosuggestHandler,
  roomString,
  checkin,
  checkout,
  destination,
  updateSearch
}) => {
  const {
    calendarBlockRef,
    paxWidgetBlockRef,
    calendarMode,
    closeCalendar,
    setCalendarMode,
    isPaxWidgetVisible,
    togglePaxWidget,
  } = useSearchWidgetUI();

  const isCalendarVisible = calendarMode !== '';

  return (
    <S.OuterWrapDiv>
      <S.OuterWrapperStyle>
        <S.WrapperStyle>
          <S.InnerWrapperStyle>
            <S.SearchOuterWrapper>
              
              <S.SearchWrapperArea>
                {(destination && destination.n && (
                  <SearchWidgetAutosuggest
                    initialInputValue={destination.n}
                    onItemSelection={changes => {
                      autosuggestHandler(changes);
                    }}
                  />
                )) || (
                  <styles.AutocompleteWrapperStyles>
                    <styles.SearchLabelStyles>
                      AREA, LANDMARK OR HOTEL NAME
                    </styles.SearchLabelStyles>
                    <styles.SearchInputStyles placeholder="LOCATION NAME" />
                  </styles.AutocompleteWrapperStyles>
                )}
              </S.SearchWrapperArea>

              <S.CheckinCheckoutWrapper id="search-widget-calendar-element">
                <styles.FieldWrapper
                  onClick={() => {
                    setCalendarMode('checkin');
                    if (isPaxWidgetVisible) togglePaxWidget(false);
                  }}
                >
                  <styles.SearchLabelStyles>CHECKIN</styles.SearchLabelStyles>
                  <styles.SearchInputStyles
                    type="text"
                    value={
                      (checkin &&
                        // checkout &&
                        `${dateFormat(checkin.date, "ddd, dd mmm 'yy")}`) ||
                      ''
                    }
                    placeholder="Travel Dates"
                    id="search-widget-checkin-input"
                    editable="false"
                    onChange={() => {}}
                  />
                </styles.FieldWrapper>
                {(calendarMode === 'checkin' && (
                  <CalendarBlock
                    ref={calendarBlockRef}
                    isSearchWidget={true}
                    isCheckinMode={calendarMode === 'checkin'}
                    isCheckoutMode={false}
                    onSelection={() => setCalendarMode('checkout')}
                    updateQueryCaller={updateQueryCaller}
                    checkin={checkin}
                    checkout={checkout}
                  />
                )) ||
                  null}
              </S.CheckinCheckoutWrapper>

              <S.CheckinCheckoutWrapper>
                <styles.FieldWrapper
                  onClick={() => {
                    setCalendarMode('checkout');
                    if (isPaxWidgetVisible) togglePaxWidget(false);
                  }}
                >
                  <styles.SearchLabelStyles>CHECKOUT</styles.SearchLabelStyles>
                  <styles.SearchInputStyles
                    type="text"
                    value={
                      (checkin && checkout && `${dateFormat(checkout.date, "ddd, dd mmm 'yy")}`) ||
                      ''
                    }
                    placeholder="Travel Dates"
                    editable="false"
                    onChange={() => {}}
                  />
                </styles.FieldWrapper>
                {(calendarMode === 'checkout' && (
                  <CalendarBlock
                    ref={calendarBlockRef}
                    isSearchWidget={true}
                    isCheckinMode={false}
                    isCheckoutMode={calendarMode === 'checkout'}
                    onSelection={() => {
                      closeCalendar();
                      updateSearch();
                    }}
                    updateQueryCaller={updateQueryCaller}
                    checkin={checkin}
                    checkout={checkout}
                  />
                )) ||
                  null}
              </S.CheckinCheckoutWrapper>

              <styles.FieldWrapper
                onClick={() => {
                  if (isCalendarVisible) closeCalendar();

                  if (!isPaxWidgetVisible) {
                    togglePaxWidget(true);
                  }
                }}
              >
                <styles.SearchLabelStyles>ROOMS & GUESTS</styles.SearchLabelStyles>
                <styles.SearchInputStyles
                  type="text"
                  value={convertRoomStringToReadable(roomString)}
                  editable="false"
                  onChange={() => {}}
                />
                {(isPaxWidgetVisible && (
                  <PaxWidget
                    isSearchWidget={true}
                    ref={paxWidgetBlockRef}
                    togglePaxWidget={togglePaxWidget}
                    updateQueryCaller={updateQueryCaller}
                    roomString={roomString}
                    updateSearch={updateSearch}
                  />
                )) ||
                  ''}
              </styles.FieldWrapper>
            </S.SearchOuterWrapper>

            <S.ButtonStyle onClick={updateSearch}>Update Search</S.ButtonStyle>
          </S.InnerWrapperStyle>
        </S.WrapperStyle>
      </S.OuterWrapperStyle>
    </S.OuterWrapDiv>
  );
};

export default SearchWidgetUI;
